module.exports = __webpack_public_path__ + "static/img/MacBookAir.340785a3.png";